module.exports = __webpack_public_path__ + "img/1573959259.1db61557.jpg";